import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'

import confirm from '@/plugins/confirm/index'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import Select2 from 'v-select2-component'
import Paginate from 'vuejs-paginate'
import Slick from 'vue-slick'
import Draggable from 'vuedraggable'
import VTooltip from 'v-tooltip'
import VuePreviewer from 'vue-image-previewer'


window.axios = require('axios')
// add oauth2 token in headers
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + token
  }
}

Vue.config.productionTip = false

import Header from './components/layouts/Header'
import Sidebar from './components/layouts/Sidebar'
import Select from './components/layouts/Select'
import Modal from './components/modals/Modal'

Vue.use(VueToast, {position: 'bottom', duration: 7000})
Vue.use(confirm)
Vue.use(VTooltip)
Vue.use(VuePreviewer, {
  defaultWidth: '50px',
  defaultHeight: '50px',
  thumbnailStyle: {
    backgroundSize: 'cover'
  },
  keyMap: {
    zoomin: '+',
    zoomout: '-',
    rotate: 'r',
    prev: 'ArrowLeft',
    next: 'ArrowRight'
  }
})

Vue.component('vue-select', Select2)
Vue.component('v-pagination', Paginate)
Vue.component('v-select', Select)
Vue.component('v-header', Header)
Vue.component('v-sidebar', Sidebar)
Vue.component('v-modal', Modal)
Vue.component('v-slick', Slick)
Vue.component('v-draggable', Draggable)

new Vue({
  router,
  store,
  Vuelidate,
  render: h => h(App),
}).$mount('#app')